


import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
} from '@vue/composition-api';

import type { StandardCarExt } from '@/models/externalReports/standard/standardCar';
import { dtFormat } from '@/lib/dateHelper';
import { PaneStyle } from '@/models/externalReports/standard/standardMap';
import {
  PANE_SIDE_HARD_MAX_WIDTH_PX,
  LIST_HARD_MAX_HEIGHT_PX,
} from '@/components/ExternalReports/Standard/consts';
import useStandardCars from '@/components/ExternalReports/Standard/composables/useCars';
import type {
  ExternalReportSettings,
  ExternalReportsLabelPc,
} from '@/models/apis/externalReports/external_report_settings';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
    showCarIcons: {
      type: Boolean,
      default: true,
    },
    paneStyle: {
      type: Object as PropType<PaneStyle>,
      default: () => ({
        paneSideMinWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
        paneSideMaxWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
        listMinHeight: LIST_HARD_MAX_HEIGHT_PX,
        listMaxHeight: LIST_HARD_MAX_HEIGHT_PX,
      }),
    },
  },
  emits: ['click-car-on-car-list', 'change-show-car-icons', 'change-photo-type-visibility'],
  setup(props, { emit }) {
    const { carState } = useStandardCars();
    const checkedShowCarIcons = ref(props.showCarIcons);
    const photoTypes = computed<string[]>(() => props.userSettings.choices.photo_types);
    const checkedPhotoTypes = ref<Record<string, boolean>>(photoTypes.value.reduce((acc, type) => {
      acc[type] = true;
      return acc;
    }, {} as Record<string, boolean>));
    const pcLabels = computed<ExternalReportsLabelPc>(() => (props.userSettings?.pc ?? {}) as ExternalReportsLabelPc);
    const visibleCars = computed<StandardCarExt[]>(() => carState.cars.filter(c => c.shouldShow));

    watch(() => props.showCarIcons, (value: boolean) => {
      checkedShowCarIcons.value = value;
    }, { immediate: true });

    const onClickCarOnCarList = (car: StandardCarExt) => {
      emit('click-car-on-car-list', car);
    };
    const onChangeShowCarIcons = () => {
      emit('change-show-car-icons');
    };

    const onChangePhotoTypeVisibility = (photoType: string) => {
      emit('change-photo-type-visibility', photoType, checkedPhotoTypes.value[photoType]);
    };
    return {
      // refs
      carState,
      photoTypes,
      checkedShowCarIcons,
      checkedPhotoTypes,
      pcLabels,
      visibleCars,
      // methods
      onClickCarOnCarList,
      onChangeShowCarIcons,
      onChangePhotoTypeVisibility,
      dtFormat,
    };
  },
});
